module.exports = __webpack_public_path__ + "img/thumbnail.5245aa20.jpg";